<template>
  <form @submit.prevent="handleSubmit">
    <div>
      <!--- Priority  !-->
      <div
        v-if="!isRpc"
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label">
          {{ $t('TARGET_ROUTE_PRIORITY') }}
          <a v-tooltip.right.hover="$t('TARGET_ROUTE_PRIORITY_TT')">
            &nbsp;&nbsp;
            <i
              class="fa fa-question-circle"
            />
          </a>
        </label>
        <ValidationProvider
          v-slot="{ classes }"
          rules="required"
          name="Priority"
        >
          <div
            class="col-sm-2 col-md-1"
            :class="classes"
          >
            <input
              v-model="viewModel.currentCallRoute.priority.priority"
              type="number"
              min="0"
              class="form-control input-sm"
            >
          </div>
        </ValidationProvider>
        <div class="col-sm-4 col-md-5">
          <label class="form-group__label-required">{{ $t("REQUIRED_LABEL") }}</label>
        </div>
      </div>

      <!--- Weight  !-->
      <div
        v-if="!isRpc"
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label">
          {{ $t('TARGET_ROUTE_WEIGHT') }}
          <a v-tooltip.right.hover="$t('TARGET_ROUTE_WEIGHT_TT')">
            &nbsp;&nbsp;<i
              class="fa fa-question-circle"
            />
          </a>
        </label>
        <ValidationProvider
          v-slot="{ classes }"
          rules="required"
          name="Weight"
        >
          <div
            class="col-sm-2 col-md-1"
            :class="classes"
          >
            <input
              v-model="viewModel.currentCallRoute.priority.weight"
              type="number"
              min="0"
              class="form-control input-sm"
            >
          </div>
        </ValidationProvider>
        <div class="col-sm-4 col-md-5">
          <label class="form-group__label-required">{{ $t("REQUIRED_LABEL") }}</label>
        </div>
      </div>

      <!--- Route Convert  !-->
      <div
        v-if="!hideConversion"
        class="form-group"
      >
        <label
          class="col-sm-3 col-md-3 control-label"
        >
          {{ $t('TARGET_ROUTE_CONVERT') }}
          <a
            v-tooltip="$t('TARGET_ROUTE_CONVERT_TT')"
            class="tooltip-icon"
          >
            <i
              class="fa fa-question-circle"
            />
          </a>
        </label>
        <ValidationProvider
          v-slot="{ classes }"
          rules="required"
          name="Convert Type"
        >
          <div
            class="col-sm-6 col-md-4"
            :class="classes"
          >
            <div class="form-selector form__searchable-dropdown">
              <TargetDropdown
                v-model="viewModel.currentCallRoute.callConversion.conversionType"
                :placeholder="'Choose Type'"
              />
            </div>
          </div>
        </ValidationProvider>
        <div class="col-sm-3 col-md-3">
          <label class="form-group__label-required">{{ $t("REQUIRED_LABEL") }}</label>
        </div>
      </div>

      <!--- Dinamic Options  !-->
      <div
        v-if="conversionTypeValue === CONVERSION_TYPES.CALL_LENGTH"
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label"> {{ $t('TARGET_ROUTE_START_EVENT') }}
          <a
            v-tooltip.right.hover="$t('TARGET_ROUTE_START_EVENT_TT')"
            class="tooltip-icon"
          >
            &nbsp;&nbsp;
            <i
              class="fa fa-question-circle"
            />
          </a>
        </label>
        <ValidationProvider
          v-slot="{ classes }"
          rules="required"
          name="Start Event"
        >
          <div
            class="col-sm-4 col-md-6"
            :class="classes"
          >
            <div
              class="btn-group"
            >
              <label
                class="btn btn-primary"
                :class="{ active: viewModel.currentCallRoute.callConversion.conversionArgs.startTimerEvent === 'OnIncomingCall' }"
              >
                <input
                  v-model="viewModel.currentCallRoute.callConversion.conversionArgs.startTimerEvent"
                  type="radio"
                  value="OnIncomingCall"
                  class="hidden"
                >
                {{ $t('TARGET_ROUTE_START_INCOMING') }}
              </label>
              <label
                class="btn btn-primary"
                :class="{ active: viewModel.currentCallRoute.callConversion.conversionArgs.startTimerEvent === 'OnDial' }"
              >
                <input
                  v-model="viewModel.currentCallRoute.callConversion.conversionArgs.startTimerEvent"
                  type="radio"
                  value="OnDial"
                  class="hidden"
                >
                {{ $t('TARGET_ROUTE_START_DIAL') }}
              </label>
              <label
                class="btn btn-primary"
                :class="{ active: viewModel.currentCallRoute.callConversion.conversionArgs.startTimerEvent === 'OnConnectedCall' }"
              >
                <input
                  v-model="viewModel.currentCallRoute.callConversion.conversionArgs.startTimerEvent"
                  type="radio"
                  value="OnConnectedCall"
                  class="hidden"
                >
                {{ $t('TARGET_ROUTE_START_CONNECT') }}
              </label>
            </div>
          </div>
        </ValidationProvider>
      </div>

      <!--- Dinamic Options - Lenght for Call Length Option !-->
      <div
        v-if="conversionTypeValue === CONVERSION_TYPES.CALL_LENGTH"
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label"> {{ $t('TARGET_ROUTE_LENGTH') }}
          <a
            v-tooltip.right.hover="$t('TARGET_ROUTE_LENGTH_TT')"
            class="tooltip-icon"
          >
            &nbsp;&nbsp;
            <i
              class="fa fa-question-circle"
            />
          </a>
        </label>
        <ValidationProvider
          v-slot="{ classes }"
          rules="required"
          name="Call Length"
        >
          <div
            class="col-sm-2 col-md-1"
            :class="classes"
          >
            <input
              v-model="viewModel.currentCallRoute.callConversion.conversionArgs.callLengthInSeconds"
              type="number"
              min="0"
              class="form-control input-sm"
            >
          </div>
        </ValidationProvider>
        <div
          class="col-sm-4 col-md-5"
        >
          <label
            class="form-group__label-required"
          >
            {{ $t("REQUIRED_LABEL") }}
          </label>
        </div>
      </div>

      <!--- Dinamic Options - Revenue !-->
      <div
        v-if="!hideConversion"
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label">
          {{ targetRevenueText }}
          <a
            v-tooltip="targetRevenueTooltipText"
            class="tooltip-icon"
          >
            <i
              class="fa fa-question-circle"
            />
          </a>
        </label>
        <ValidationProvider
          v-slot="{ classes }"
          rules="required"
          name="Revenue"
        >
          <div
            class="col-sm-2 col-md-1"
            :class="classes"
          >
            <span class="currency">$</span>
            <input
              v-model="viewModel.currentCallRoute.callConversion.conversionValue"
              type="number"
              min="0"
              step="0.01"
              class="form-control currency input-sm"

              placeholder=""
            >
          </div>
        </ValidationProvider>
        <div class="col-sm-4 col-md-5">
          <label
            class="form-group__label-required"
          >
            {{ $t("REQUIRED_LABEL") }}
          </label>
        </div>
      </div>

      <!-- Duplication Setting -->
      <div
        v-if="!hideDuplicate"
        class="form-group"
      >
        <label class="col-sm-3 col-md-3 control-label double-line">
          {{ $t('TARGET_ROUTE_DUPLICATE') }}
          <a v-tooltip.right.hover="$t('TARGET_ROUTE_DUPLICATE_TT')">
            &nbsp;&nbsp;
            <i
              class="fa fa-question-circle"
            />

          </a>
        </label>
        <div class="col-sm-4 col-md-6">
          <ConversionDuplicationToggle
            :view-model="viewModel"
            :disabled="false"
          />
        </div>
      </div>

      <!-- Submit -->
      <div
        class="form-group row"
      >
        <div class="col-md-offset-3 col-sm-offset-3 col-md-8 col-sm-8">
          <button
            type="submit"
            class="btn btn-primary btn-sm"
          >
            <span
              v-if="viewModel.loading"
              class="spinner"
            />
            <span v-t="'ADD'" />
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import TargetDropdown from './TargetDropdown.vue';
import { CallRouteFormViewModel } from '../models/CallRouteFormViewModel';
import ConversionDuplicationToggle from './ConversionDuplicationToggle.vue';
import { CONVERSION_TYPES, validRowContainerTypes} from '../apiConstants';


export default defineComponent({
  name: 'CallRouteForm',
  components: { TargetDropdown, ConversionDuplicationToggle },
  props: {
    currentCallRoute: Object,
    hideConversion: Boolean,
    hideDuplicate: Boolean,
    isRpc: Boolean,
    selectedTarget: Object,


    routeContainerType: {
      type: String,
      required: true,
      validator: (value) => validRowContainerTypes.includes(value)
    },
    routeContainer: {
      type: Object,
      required: true
    },
    onSubmitSuccess: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      viewModel:  reactive (new CallRouteFormViewModel(this.currentCallRoute, this.selectedTarget)),
      CONVERSION_TYPES,
    };
  },
  created() {
    this.viewModel.loadConversionSettings();
    this.viewModel.loadDefaultPriorityDataIfRPC(this.isRpc);
  },
  computed: {
    conversionTypeValue() {
      const conv = this.viewModel.currentCallRoute.callConversion?.conversionType;
      return conv && typeof conv === 'object' ? conv.conversionType : conv;
    },
    shouldShowGeneralConversion() {
      return !this.hideConversion;
    },
    targetRevenueText() {
      return this.conversionTypeValue === CONVERSION_TYPES.POSTBACK
        ? this.$t('TARGET_ROUTE_REVENUE_POSTBACK')
        : this.$t('TARGET_ROUTE_REVENUE');
    },
    targetRevenueTooltipText() {
      return this.conversionTypeValue === CONVERSION_TYPES.POSTBACK
        ? this.$t('TARGET_ROUTE_REVENUE_POSTBACK_TT')
        : this.$t('TARGET_ROUTE_REVENUE_TT');
    },
  },
  methods: {
    /**
     * Handle form submission
     * @param {Event} event - Form submit event
     */
    async handleSubmit() {
      try {
        await this.viewModel.submitRoute(this.routeContainerType, this.routeContainer);
        this.onSubmitSuccess({ routeContainer: this.routeContainer });
      } catch (error) {
        console.error('Form submission error:', error);
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});
</script>